import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import LogRocket from 'logrocket';
import { Helmet } from 'react-helmet';
import { Button, Icon } from 'semantic-ui-react';

import RequestEditModal from './components/RequestEditModal';
import PublishModal from './components/PublishModal';
import InitialModal from './components/InitialModal';
import './style/PublishBanner.css';

export default class PublishBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showRequestEditModal: null,
      showPublishModal: null,
      showBanner: props.defaultShowBanner,
      toShow: true,
      showInitialModal: false,
      checkedOut: false,
    };

    this.onCartClick = this.onCartClick.bind(this);
    this.onMinimizeClick = this.onMinimizeClick.bind(this);
    this.needsToPay = this.needsToPay.bind(this);
    this.handleRequestClose = this.handleRequestClose.bind(this);
    this.handlePublishClose = this.handlePublishClose.bind(this);
    this.handleRequestOpen = this.handleRequestOpen.bind(this);
    this.handlePublishOpen = this.handlePublishOpen.bind(this);
    this.handleInitialClose = this.handleInitialClose.bind(this);
    this.onCheckoutCompleted = this.onCheckoutCompleted.bind(this);
    this.setInitialModalTimer = this.setInitialModalTimer.bind(this);
    this.openInitialModal = this.openInitialModal.bind(this);
  }

  async componentDidMount() {
    const { business } = this.props;
    const { name } = business;
    LogRocket.init('abqepz/fisherman-websites');
    LogRocket.identify(name);

    const status = await this.needsToPay();
    this.setState({ toShow: status }, this.setInitialModalTimer);
  }

  onMinimizeClick() {
    this.setState({ showBanner: false });
  }

  onCartClick() {
    this.setState({ showBanner: true });
  }

  onCheckoutCompleted() {
    this.setState({ checkedOut: true });
  }

  setInitialModalTimer() {
    setTimeout(this.openInitialModal, 15000);
  }

  openInitialModal() {
    this.setState({ showInitialModal: true });
  }

  handlePublishClose() {
    const { checkedOut } = this.state;
    this.setState({ showPublishModal: false }, () => {
      if (checkedOut) {
        this.setState({ toShow: false });
      }
    });
  }

  handleRequestOpen() {
    this.setState({ showRequestEditModal: true, showInitialModal: false });
  }

  handlePublishOpen() {
    this.setState({ showPublishModal: true, showInitialModal: false });
  }

  handleRequestClose() {
    this.setState({ showRequestEditModal: false });
  }

  handleInitialClose() {
    this.setState({ showInitialModal: false });
  }

  async needsToPay() {
    const { business } = this.props;
    const url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
    const headers = { 'x-api-key': process.env.X_API_KEY || process.env.STORYBOOK_X_API_KEY };
    try {
      const resp = await axios.get(
        `${url}businesses/${business.type}s/${business.id}/subscriptions/`,
        { headers },
      );
      const { status, data } = resp;

      if (status === 404) {
        return false;
      }

      return data.stripe_data == null;
    } catch (e) {
      return true;
    }
  }

  render() {
    const { business, defaultDomain, enablePopup, collectEmail } = this.props;
    const {
      toShow,
      showBanner,
      showRequestEditModal,
      showPublishModal,
      checkedOut,
      showInitialModal,
    } = this.state;

    return (
      toShow && (
        <React.Fragment>
          {enablePopup &&
            showInitialModal &&
            showRequestEditModal === null &&
            showPublishModal === null && (
              <InitialModal
                handlePublishOpen={this.handlePublishOpen}
                handleRequestOpen={this.handleRequestOpen}
                handleInitialClose={this.handleInitialClose}
              />
            )}
          {showBanner ? (
            <div className="payment-banner">
              <Helmet>
                <script src="https://js.stripe.com/v3/" />
              </Helmet>
              <RequestEditModal
                showRequestEditModal={showRequestEditModal}
                handleRequestOpen={this.handleRequestOpen}
                handleRequestClose={this.handleRequestClose}
                handlePublishOpen={this.handlePublishOpen}
                handleRequestEditClose={this.handleRequestClose}
                business={business}
              />
              <PublishModal
                showPublishModal={showPublishModal}
                handlePublishOpen={this.handlePublishOpen}
                handlePublishClose={this.handlePublishClose}
                onCheckoutCompleted={this.onCheckoutCompleted}
                business={business}
                defaultDomain={defaultDomain}
                checkedOut={checkedOut}
                collectEmail={collectEmail}
              />
              <Button
                id="minimize-icon-button"
                className="minimize-icon-container"
                onClick={this.onMinimizeClick}
              >
                <Icon name="close" className="minimize-icon" />
              </Button>
            </div>
          ) : (
            <Button
              id="cart-icon-button"
              className="cart-icon-container payment-publish-button"
              onClick={this.onCartClick}
            >
              Sign Up
            </Button>
          )}
        </React.Fragment>
      )
    );
  }
}

PublishBanner.propTypes = {
  business: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.oneOf(['restaurant', 'generic']).isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  defaultDomain: PropTypes.string.isRequired,
  defaultShowBanner: PropTypes.bool.isRequired,
  enablePopup: PropTypes.bool,
  collectEmail: PropTypes.bool,
};

PublishBanner.defaultProps = {
  enablePopup: false,
  collectEmail: false,
};
